var _this = this;

/* eslint-disable no-useless-escape */

/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 11:38:25
 * @LastEditTime: 2021-04-06 19:05:06
 */
// let userAgent = window.navigator.userAgent;
import cookie from './cookie';
import miloUrl from './url'; // ===浏览器相关

var platform = {
  /**
   * 获取版本号
   */
  version: function version() {
    return (window.navigator.userAgent.match(/.+(?:rv|it|ra|ie|msdk|MicroMessenger)[\/: ]([\d.]+)/) || [0, '0'])[1];
  },

  /**
   * 是否webkit浏览器
   */
  webkit: function webkit() {
    return /webkit/.test(window.navigator.userAgent);
  },

  /**
   * 是否opera浏览器
   */
  opera: function opera() {
    return /opera/.test(window.navigator.userAgent);
  },

  /**
   * 是否IE浏览器
   */
  msie: function msie() {
    return /msie/.test(window.navigator.userAgent) && !/opera/.test(window.navigator.userAgent);
  },

  /**
   * 是否mozilla浏览器
   */
  mozilla: function mozilla() {
    return /mozilla/.test(window.navigator.userAgent) && !/(compatible|webkit)/.test(window.navigator.userAgent);
  },

  /**
   * 是否TT浏览器
   */
  tt: function tt() {
    return /tencenttraveler/.test(window.navigator.userAgent);
  },

  /**
   * 是否chrome浏览器
   */
  chrome: function chrome() {
    return /chrome/.test(window.navigator.userAgent);
  },

  /**
   * 是否firefox浏览器
   */
  firefox: function firefox() {
    return /firefox/.test(window.navigator.userAgent);
  },

  /**
   * 是否safari浏览器
   */
  safari: function safari() {
    return /safari/.test(window.navigator.userAgent);
  },

  /**
   * 是否gecko浏览器
   */
  gecko: function gecko() {
    return /gecko/.test(window.navigator.userAgent);
  },

  /**
   * 是否IE6
   */
  ie6: function ie6() {
    return _this.msie && _this.version.substr(0, 1) == '6';
  },
  // 是否移动端
  isMobile: function isMobile() {
    if (window.milo_plat) {
      return window.milo_plat.toUpperCase() == 'MOBILE';
    }

    return /iphone|ios|android|mini|mobile|mobi|Nokia|Symbian|iPod|iPad|Windows\s+Phone|MQQBrowser|wp7|wp8|UCBrowser7|UCWEB|360\s+Aphone\s+Browser|blackberry/i.test(window.navigator.userAgent);
  },
  // 是否msdk浏览器
  isMSDK: function isMSDK() {
    return /msdk/i.test(window.navigator.userAgent) || miloUrl.request('msdkEncodeParam') || miloUrl.request('itopencodeparam');
  },
  // 是否msdkV3浏览器
  isMSDKV3: function isMSDKV3() {
    return /msdk/i.test(window.navigator.userAgent) || miloUrl.request('msdkEncodeParam');
  },
  // 是否msdkv5浏览器
  isMSDKV5: function isMSDKV5() {
    return /MSDK\/5/i.test(window.navigator.userAgent) || miloUrl.request('itopencodeparam');
  },
  // 是否tbs内核
  isTBS: function isTBS() {
    return /TBS/gi.test(window.navigator.userAgent);
  },
  // 是否手Q
  isQQApp: function isQQApp() {
    var REGEXP_IOS_QQ = new RegExp('(iPad|iPhone|iPod).*? (IPad)?QQ\\/([\\d\\.]+)');
    var REGEXP_ANDROID_QQ = new RegExp('\\bV1_AND_SQI?_([\\d\\.]+)(.*? QQ\\/([\\d\\.]+))?', 'ig'); // 判断是否是IOSQQ 或者 AndroidQQ打开

    var isIphoneOs_QQ = REGEXP_IOS_QQ.test(window.navigator.userAgent);
    var isAndroid_QQ = REGEXP_ANDROID_QQ.test(window.navigator.userAgent);
    return isIphoneOs_QQ || isAndroid_QQ;
  },
  // 是否微信
  isWxApp: function isWxApp() {
    return /MicroMessenger/gi.test(window.navigator.userAgent);
  },
  // 是否手机QQ浏览器
  isMQQBrowser: function isMQQBrowser() {
    /* 由于使用了QQ浏览器内核，部分手机的微信中会显示 MicroMessenger + MQQBrowser，所要先排除微信
         手Q的内置浏览器，也改成了 MQQBrowser 的内核，需要先排除*/
    if (this.isWxApp() || this.isQQApp() || this.isTBS()) {
      return false;
    }

    return /MQQBrowser/gi.test(window.navigator.userAgent);
  },
  // 是否QQ浏览器(PC端)
  isQQBrowser: function isQQBrowser() {
    return /\sQQBrowser/gi.test(window.navigator.userAgent);
  },
  // 是否iPad
  ipad: function ipad() {
    return /ipad/i.test(window.navigator.userAgent);
  },
  // 是否iPhone
  iphone: function iphone() {
    return /iphone/i.test(window.navigator.userAgent);
  },
  ipod: function ipod() {
    var regular_result = window.navigator.userAgent.match(/(iPod).*OS\s([\d_]+)/);
    var os_boolean = !!regular_result;
    return os_boolean;
  },
  // 是否Android系统
  android: function android() {
    return /Android/i.test(window.navigator.userAgent);
  },
  // 是否ios系统
  ios: function ios() {
    return /(ipad|iphone|ipod)/i.test(window.navigator.userAgent);
  },
  screen: function screen() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  },
  isYYB: function isYYB() {
    return /\/qqdownloader\/(\d+)(?:\/(appdetail|external|sdk))?/.test(window.navigator.userAgent);
  },
  isTV: function isTV() {
    return /(QQLive|WeTV)(HD|Kid)?(Browser|_MAC)?[\s/]*(\d+(\.\d+)*)/i.test(window.navigator.userAgent);
  },
  isGamer: function isGamer() {
    return /android\/gamer/.test(window.navigator.userAgent.toLowerCase());
  },
  isQB: function isQB() {
    return /QQBrowser/.test(window.navigator.userAgent);
  },
  isNews: function isNews() {
    return /qqnews/.test(window.navigator.userAgent);
  },
  isEGame: function isEGame() {
    return /\bcom\.tencent\.qgame\/([\d\.]+)/.test(window.navigator.userAgent.toLowerCase());
  },
  isTgClub: function isTgClub() {
    return /tgclub/.test(window.navigator.userAgent.toLowerCase());
  },
  isMusic: function isMusic() {
    return /qqmusic/.test(window.navigator.userAgent.toLowerCase());
  },
  isSecure: function isSecure() {
    return /MQQSecure/.test(window.navigator.userAgent) || /WeSecure/.test(window.navigator.userAgent);
  },
  isXRiver: function isXRiver() {
    return /XRiver/.test(window.navigator.userAgent);
  },
  isLoLApp: function isLoLApp() {
    return /lolapp/.test(window.navigator.userAgent.toLowerCase());
  },
  isDJC: function isDJC() {
    return cookie.get('djc_appVersion') != null && cookie.get('djc_appVersion') >= 62 || typeof HostApp != 'undefined';
  },
  isAC: function isAC() {
    return /QQAC_Client/.test(window.navigator.userAgent);
  },
  isDouyin: function isDouyin() {
    return /aweme/.test(window.navigator.userAgent.toLowerCase());
  }
};
export default platform;